import { MrbBaseRouteStore } from "mrb/core";
import { UploadedContentService } from "common/services";

class UploadedContentSessionRouteStore extends MrbBaseRouteStore {
    constructor(rootStore, options) {
        super(rootStore, options);
        this.service = this.rootStore.createApplicationService(UploadedContentService);
    }

    get sessionId() {
        return this.rootStore.routerStore.routerState.params.sessionId;
    }

    async getFiles(params) {
        const response = await this.service.find({ ...params, session: this.sessionId });
        return response.data;
    }

    async getDownloadUrls(keys) {
        const response = await this.service.getDownloadUrls(keys);
        return response.data;
    }

    createDownloadUrl(key) {
        const baseUrl = this.rootStore.application.baasic.getApiUrl();
        const base = this.service.routeService.getFileDownload(key);
        return `${baseUrl}${base}`;
    }

    async getSessionDescription() {
        try {
            const response = await this.service.getSessionDescription(this.sessionId);
            return response.data?.description || null;
        } catch {
            return null;
        }
    }
}

export { UploadedContentSessionRouteStore };
